import * as React from "react";
import "../../../react/jsx-runtime.es.js";
const defaultContextValue = {
  disableDefaultClasses: false
};
const ClassNameConfiguratorContext = /* @__PURE__ */ React.createContext(defaultContextValue);
if (process.env.NODE_ENV !== "production") {
  ClassNameConfiguratorContext.displayName = "ClassNameConfiguratorContext";
}
function useClassNamesOverride(generateUtilityClass) {
  const {
    disableDefaultClasses
  } = React.useContext(ClassNameConfiguratorContext);
  return (slot) => {
    if (disableDefaultClasses) {
      return "";
    }
    return generateUtilityClass(slot);
  };
}
export {
  useClassNamesOverride
};
//# sourceMappingURL=ClassNameConfigurator.es.js.map
